const de = {
  push: 'Neue Liste',
  check: 'Erstellen',
  cancel: 'Abbrechen',
  name: 'Liste',
}
export default de;